import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("vue-editor", {
    staticStyle: {
      display: "none"
    }
  }), _c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Back.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "img-wrap"
  })]), _vm.name == "Follow" || _vm.name == "Fans" ? _c("div", {
    staticClass: "search"
  }, [_c("van-search", {
    attrs: {
      "left-icon": _vm.leftIcon,
      background: "#000",
      placeholder: "Search"
    },
    on: {
      input: _vm.input
    },
    model: {
      value: _vm.nickname,
      callback: function callback($$v) {
        _vm.nickname = $$v;
      },
      expression: "nickname"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "content"
  }, [_vm.name == "Follow" || _vm.name == "Fans" ? _c("div", _vm._l(_vm.followList, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item2"
    }, [_c("div", {
      staticClass: "left",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toMe(item.user.pid);
        }
      }
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "wrap"
    }, [_c("span", {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(item.user.nickName))])])]), _vm.userId != item.user.pid ? _c("div", [_c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.userFollow.isMutual && !item.userFollow.isFollow,
        expression: "!item.userFollow.isMutual && !item.userFollow.isFollow"
      }],
      staticClass: "follow",
      on: {
        click: function click($event) {
          return _vm.toFollow(item.user.pid, item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("Follow")))]), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.userFollow.isMutual && item.userFollow.isFollow,
        expression: "item.userFollow.isMutual && item.userFollow.isFollow"
      }],
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          return _vm.toUnfollow(item.user.pid, item);
        }
      }
    }, [_vm._v("Friends")]), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.userFollow.isMutual && item.userFollow.isFollow,
        expression: "!item.userFollow.isMutual && item.userFollow.isFollow"
      }],
      staticClass: "unFollow",
      on: {
        click: function click($event) {
          return _vm.toUnfollow(item.user.pid, item);
        }
      }
    }, [_vm._v("Unfollow")])]) : _vm._e()]);
  }), 0) : _c("div", _vm._l(_vm.clubData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "club-item"
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info"
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt))])])])]), _c("div", {
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.categoryName);
        }
      }
    }, [_c("div", {
      staticClass: "explain ql-editor",
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    }), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
      staticClass: "img-con"
    }, _vm._l(item["content"]["indexes"]["101"]["body"], function (itm) {
      return _c("div", {
        key: itm.thumbUrl,
        staticClass: "imgBg",
        style: "background:url(" + itm.thumbUrl + ") no-repeat center;background-size:cover;"
      });
    }), 0) : _vm._e()]), item.topic.length > 0 ? _c("div", {
      staticClass: "tags"
    }, _vm._l(item.topic, function (item1) {
      return _c("div", {
        key: item1.id,
        staticClass: "tags-item",
        on: {
          click: function click($event) {
            return _vm.toTopic(item1.id);
          }
        }
      }, [_c("img", {
        staticClass: "sign",
        attrs: {
          src: require("../../assets/images/Topic-list-icon-blue.png"),
          alt: ""
        }
      }), _c("span", {
        staticClass: "clubs"
      }, [_vm._v(_vm._s(item1.content))])]);
    }), 0) : _vm._e(), _c("div", {
      staticClass: "user-operate",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.categoryName);
        }
      }
    }, [_c("div", {
      staticClass: "item-con"
    }, [_c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/Comments.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.likeReward.postCount))])]), _c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/Like.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.likeReward.likePayCount))])]), _c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../assets/images/Collection.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.likeReward.favoriteCount))])])]), _c("img", {
      attrs: {
        src: require("../../assets/images/Share.png"),
        alt: ""
      }
    })])]);
  }), 0)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };